














































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

@Component({})
export default class AccessControl extends Vue {
  private roles: string[] = [];

  private isSaving: boolean = false;

  private selectedRoles: string[] = [];

  private existingRoles: any[] = [];

  get selectableRoles() {
    return this.existingRoles.filter((role) => !this.roles.includes(role.value));
  }

  protected async created() {
    const apps = await axios.get('acl/apps');
    this.existingRoles = [];
    if (apps.data) {
      this.existingRoles = (apps.data as string[]).map((policy) => ({
        key: policy,
        text: policy.replace('app-', ''),
        value: policy
      }));
    }
    const roles = await axios.get('acl');
    this.roles = roles.data || [];
  }

  protected async addRole() {
    const expanded = this.roles.concat(this.selectedRoles);
    await this.save(expanded);
  }

  protected async deleteRole(role) {
    const filtered = this.roles.filter((r) => r !== role);
    await this.save(filtered);
  }

  protected allowAll() {
    return this.save(this.existingRoles.map((it) => it.value));
  }

  protected denyAll() {
    return this.save([]);
  }

  private async save(roles) {
    this.isSaving = true;
    try {
      await axios.post('acl', roles);
      this.roles = roles;
      this.selectedRoles = [];
    } catch (e) {
      this.$notify({ type: 'error', text: e.message });
    }
    this.isSaving = false;
  }

}
